<template>
  <b-card>
    <DeleteRewardModal
      :reward="toBeDeletedReward"
      @deleted="getRewards"
    />
    <base-overlay :show="fetching">
      <b-row>
        <b-col md="4">
          <b-tooltip
            v-if="totalRewards == 20"
            target="add-challenge-target"
            triggers="hover"
          >
            You’ve reached the limit of 20 total challenges.
          </b-tooltip>
          <div
            id="add-challenge-target"
            style="width: fit-content;"
          >
            <b-button
              v-if="$can('write', 'rewards')"
              :disabled="totalRewards == 20"
              class="mb-2"
              variant="primary"
              to="/create-challenge"
            >
              Add Challenge
            </b-button>

          </div>
        </b-col>
      </b-row>
      <b-table
        :items="rewardsList"
        responsive
        :fields="tableColumns"
        show-empty
        empty-text="No matching rewards found"
      >
        <template #cell(actions)="data">
          <b-dropdown
            variant="link"
            no-caret
          >
            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>
            <b-dropdown-item
              v-if="$can('write', 'rewards')"
              :to="{
                name: 'edit-challenge',
                params: { id: data.item.id },
              }"
            >
              <feather-icon icon="EyeIcon" />
              <span class="align-middle ml-50">View</span>
            </b-dropdown-item>
            <b-dropdown-item
              v-if="$can('delete', 'rewards')"
              @click="deletePopupHandler(data.item)"
            >
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50">Delete</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>
      <base-pagination
        v-model="queryParams.page"
        :total="totalRewards"
        @input="getRewards"
        @new-per-page="queryParams.perPage = $event"
      />
    </base-overlay>
  </b-card>
</template>

<script>
import {
  BTable, BButton, BCard, BDropdown, BDropdownItem, BRow, BCol, BTooltip,
} from 'bootstrap-vue'
import useRegisterStoreModule from '@/hooks/useRegisterStoreModule'
import BasePagination from '@/UI/BasePagination.vue'
import useRewardsList from '../../hooks/useRewardsList'
import store from '../../store'
import DeleteRewardModal from '../../components/DeleteRewardModal.vue'

export default {
  components: {
    BTable,
    BButton,
    BCard,
    DeleteRewardModal,
    BDropdown,
    BasePagination,
    BDropdownItem,
    BRow,
    BCol,
    BTooltip,
  },
  setup(_, ctx) {
    useRegisterStoreModule('rewards', store)
    return {
      ...useRewardsList(ctx, 'USER'),
    }
  },
}
</script>

    <style>

    </style>
